var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "7935ec95c421cee6d86eb22ecd1563fb"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    fill: ""
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M269.248,261.678h-10.431c-2.167-8.413-5.52-16.338-9.849-23.624l7.356-7.353 c5.91-5.914,7.108-14.305,2.674-18.74l-16.059-16.058c-4.437-4.436-12.823-3.238-18.737,2.677l-7.438,7.444 c-7.171-4.214-14.963-7.489-23.222-9.619v-10.431c0-8.361-5.082-15.141-11.355-15.141h-22.711c-6.273,0-11.355,6.779-11.355,15.141 v10.431c-8.258,2.129-16.046,5.401-23.218,9.615l-7.44-7.44c-5.915-5.915-14.302-7.112-18.737-2.677l-16.058,16.058 c-4.437,4.435-3.238,12.826,2.676,18.74l7.353,7.349c-4.329,7.282-7.682,15.215-9.848,23.628H72.418 c-8.361,0-15.141,5.087-15.141,11.355v22.711c0,6.273,6.779,11.355,15.141,11.355H82.85c2.126,8.258,5.404,16.05,9.614,23.222 l-7.438,7.438c-5.917,5.914-7.115,14.306-2.68,18.741l16.058,16.057c4.437,4.437,12.827,3.238,18.737-2.676l7.356-7.355 c7.282,4.332,15.215,7.681,23.624,9.848v10.431c0,8.361,5.082,15.141,11.355,15.141h22.711c6.273,0,11.355-6.779,11.355-15.141 v-10.431c8.414-2.167,16.343-5.523,23.629-9.848l7.352,7.355c5.911,5.914,14.302,7.112,18.737,2.676l16.058-16.064 c4.437-4.428,3.238-12.819-2.68-18.733l-7.438-7.438c4.211-7.172,7.489-14.964,9.615-23.222h10.431 c8.361,0,15.142-5.082,15.142-11.355v-22.711C284.39,266.765,277.609,261.678,269.248,261.678z M170.833,341.167 c-31.309,0-56.777-25.469-56.777-56.778c0-31.309,25.469-56.777,56.777-56.777c31.31,0,56.777,25.468,56.777,56.777 C227.61,315.698,202.143,341.167,170.833,341.167z M454.723,141.498v351.076c0,10.409-8.518,18.926-18.926,18.926H76.203 c-10.409,0-18.926-8.517-18.926-18.926v-56.777h37.852v37.852H416.87V151.908h-86.109c-15.097,0-27.445-12.354-27.445-27.446 v-86.11H95.129v94.63H57.277V19.425C57.277,9.017,65.794,0.5,76.203,0.5h236.102v0.066c3.016,0.277,6.587,2.24,10.42,6.069 l125.861,125.861c3.247,3.246,5.154,6.307,5.833,9.001H454.723z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupIcon);
export default __webpack_public_path__ + "static/media/setup-icon.ad1a0f96697071fb0ce8f6c186f06ce7.svg";
export { ForwardRef as ReactComponent };